export default {
  TradeTypeList: [
    {
      label: '——',
      value: -1,
    },
    {
      label: '海外直邮',
      value: 4,
    },
    {
      label: '跨境保税',
      value: 5,
    },
    {
      label: '完税进口',
      value: 6,
    },
    {
      label: '国内贸易',
      value: 7,
    },
  ],
  TradeTypeEnum: {
    overseas: 4,
    bonded: 5,
    normal: 6,
  },
  recordTypeListView: [
    {
      label: '——',
      value: 0,
    },
    {
      label: '未备案',
      value: 1,
    },
    {
      label: '已备案',
      value: 2,
    },
  ],
  goodsQuartzTypeList: [
    {
      label: '${time}定时任务${count}条失败',
      value: 0,
    },
    {
      label: '因支付通道/贸易类型被删除${count}个商品下架',
      value: 1,
    },
    {
      label: '因备案信息被删除${count}个商品下架',
      value: 2,
    },
    {
      label: '已补全海关备案信息${count}个，可操作上架',
      value: 3,
    },
  ],
  appletTypeEnum: [
    {
      label: '微信小程序',
      value: 1,
    },
    {
      label: '支付宝小程序',
      value: 2,
    },
    {
      label: 'H5',
      value: 3,
    },
    {
      label: '支付宝澳门',
      value: 4,
    },
  ],
  // 商品类型
  goodsTypeList: [
    {
      label: '全部',
      value: -1,
    },
    {
      label: '普通商品',
      value: 0,
    },
    {
      label: '分销商品',
      value: 1,
    },
  ],
  goodsStatus: {
    1: '待上架',
    2: '出售中',
    3: '仓库中',
    4: '已失效',
  },
  distributionTypeList: [
    {
      label: '快递直邮',
      value: 1,
    },
    // {
    //   label: '预约自提',
    //   value: 2,
    // },
    {
      label: '本地配送',
      value: 4,
    },
  ],
};
